var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boards-for-user"},[_c('PHeader'),_c('UserProfileCard',{attrs:{"in-board":true,"username":_vm.filters.boardUsername}}),_c('Boards',{attrs:{"filters":_vm.filters}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }